module.exports = __webpack_public_path__ + "static/img/bindmessage.a3fd6fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bindmessage.png
// module id = pRzS
// module chunks = 136